import { render, staticRenderFns } from "./LogoGroup.vue?vue&type=template&id=96c7bca8&scoped=true&"
import script from "./LogoGroup.vue?vue&type=script&lang=js&"
export * from "./LogoGroup.vue?vue&type=script&lang=js&"
import style0 from "./LogoGroup.vue?vue&type=style&index=0&id=96c7bca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c7bca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
